export function defaultSpeakTab(enabled, search = '') {
  const params = new URLSearchParams(search);
  const activityKeys = [
    'topic',
    'topic_category',
    'subtopic',
    'subtopic_category',
    'chat_key',
    'selectedOption',
    'selected_option',
  ];
  return enabled && !activityKeys.some((key) => params.get(key))
    ? 'my_path'
    : 'browse';
}
